'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const communityServices: { label: string; href?: string }[] = [
  { label: "Marathi Brahmin surnames" },
  { label: "Marathi Brahmin" },
  { label: "Marathi Brahmin brides" },
  { label: "Marathi Brahmin Grooms" },
  { label: "Marathi Brahmin wedding" },
  { label: "Marathi Brahmin wedding rituals" },
  { label: "Marathi Brahmin Surnames List" },
  { label: "Marathi Brahmin wedding dress" },
  { label: "Marathi Brahmin girls" },
  { label: "Marathi Brahmin Matrimony Sites" },
  { label: "Marathi Brahmin Lagna Patrika" },
  { label: "Marathi Brahmin caste" },
  { label: "Marathi Brahmin Matrimony WhatsApp Group Link" },
  { label: "Marathi Brahmin girl names" },
  { label: "Marathi Brahmin Gotra List" },
  { label: "Marathi Brahmin near me" },
  { label: "Marathi Brahmin marriage rituals" },
  { label: "Marathi Brahmin Vadhu Var Suchak Kendra" },
  { label: "Brahmin Vadhu Var Suchak Mandal" },
  { label: "Brahmin Vadhu Var Suchak Mandal Pune" },
  { label: "Brahmin Vadhu List" },
  { label: "Brahmin Vadhu Var WhatsApp Group" },
  { label: "Brahmin Vadhu Var Suchak" },
  { label: "Brahmin Vadhu Var WhatsApp group Marathi" },
  { label: "Brahmin Vadhu Var Suchak Mandal Kolhapur" },
  { label: "Brahmin Vadhu Var Suchak Mandal Mumbai" },
  { label: "Brahmin Vadhu List PDF" },
  { label: "Brahmin Vadhu Var Biodata" },
  { label: "Brahmin Vadhu Var Suchak Mandal Nashik" },
  { label: "Kokanastha Brahmin Vadhu Var Suchak Kendra" },
  { label: "Brahmin Vadhu Var Melava" },
  { label: "Pune Brahmin Vadhu Var Suchak Mandal" },
  { label: "Marathi Brahmin Vadhu Var Suchak Kendra" },
  { label: "Brahmin Vadhu Var Suchak Mandal Nagpur" },
  { label: "Brahmin Vadhu Var Suchak Mandal in Dombivali" },
  { label: "Brahmin Vadhu Var Suchak Mandal Thane" },
  { label: "Brahmin Vadhu Var Suchak Mandal in Pune" },
  { label: "Kokanastha Brahmin" },
  { label: "Kokanastha Brahmin brides" },
  { label: "Kokanastha Matrimony" },
  { label: "Kokanastha Brahmin Matrimony" },
  { label: "96k Kokanastha caste" },
  { label: "Kokanastha Brahmin Girls" },
  { label: "Kokanastha Maratha" },
  { label: "Why are Kokanastha Brahmin fair" },
  { label: "Chitpavan Kokanastha Brahmin" },
  { label: "96 Kuli Kokanastha Maratha Brides" },
  { label: "Kokanastha Brahmins" },
  { label: "Kokanastha Maratha Matrimony" },
  { label: "Kokanastha Brahmin marriage rituals" },
  { label: "Kokanastha Brahmin surnames and Gotras" },
  { label: "Chitpavan Brahmin" },
  { label: "Chitpavan Brahman Sangh" },
  { label: "Chitpavan Brahmins" },
  { label: "Chitpavan Matrimony" },
  { label: "GSB Konkani Matrimonial" },
  { label: "Matrimony sites for Marathi Brahmins" },
  { label: "GSB Matrimonial" },
  { label: "Mumbai GSB Konkani Matrimony" },
  { label: "GSB Seva Mandal Ganpati" },
  { label: "GSB Seva Mandal" },
  { label: "Brahmin Saraswat Grooms and Brides" },
  { label: "Konkanastha Chitpavan Brahmin" },
  { label: "Gaud Saraswat Brahmins" },
  { label: "Marathi Rajapur Saraswat Brahmins" },
];

export default function MarathiBrahminMatrimony() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      {/* Transparent Header */}
      <Header variant="transparent" />

      <HomeHeroSection
        title="मराठी ब्राह्मण वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="marathi_brahmin_matrimony"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Frequently Asked Questions
          </h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {[
                {
                  question: "Which is the best matrimonial site for Maharashtrian Brahmin?",
                  answer: "MarathiVadhuVarSuchak.com is the best matrimonial site for Maharashtrian Brahmin Vadhu Var."
                },
                {
                  question: "Which is the highest Brahmin caste in Maharashtra?",
                  answer: "Marathi Brahmins are about 8 to10 percent of the total population of Maharashtra state. Among Maharashtrian Marathi Brahmins, almost 60% are Deshastha Brahmins and 20% are Chitpavan Brahmins."
                },
                {
                  question: "Which matrimonial site is best for Brahmins?",
                  answer: "MarathiVadhuVarSuchak.com is the best matrimonial site for Marathi Brahmins."
                },
                {
                  question: "How to join Marathi Brahmin matrimony WhatsApp group link?",
                  answer: "Due to strict privacy policy, MarathiVadhuVarSuchak.com Marathi matrimony does not have any WhatsApp group link to join."
                },
                {
                  question: "How to search Marathi Brahmin matrimony girl profiles?",
                  answer: "Register free on MarathiVadhuVarSuchak.com to search Marathi Brahmin matrimony Vadhu profiles."
                },
                {
                  question: "Which is the best Brahmin Matrimony Maharashtra?",
                  answer: "MarathiVadhuVarSuchak.com is the best Brahmin Matrimony in Maharashtra state."
                },
                {
                  question: "Which is the best Free Marathi Brahmin matrimony?",
                  answer: "MarathiVadhuVarSuchak.com is the best Marathi Brahmin matrimony for free registration."
                },
                {
                  question: "Which are the best Matrimony sites for Brahmins in Maharashtra?",
                  answer: "There are many options, but MarathiVadhuVarSuchak.com is the most trusted Marathi Brahmin matrimony for free registration."
                },
                {
                  question: "Which is the best Brahmin Matrimony Pune?",
                  answer: "MarathiVadhuVarSuchak.com is the trusted Marathi Brahmin matrimony for Pune based grooms and brides."
                },
                {
                  question: "Which is the trusted Brahmin Vadhu Var Suchak Mandal Mumbai?",
                  answer: "MarathiVadhuVarSuchak.com is the trusted Brahmin Vadhu Var Suchak Mandal in Mumbai city."
                },
                {
                  question: "How to join the Brahmin Vadhu Var WhatsApp group?",
                  answer: "Privacy policy of MarathiVadhuVarSuchak.com is very strict, so we do not have any WhatsApp group."
                },
                {
                  question: "How to search Brahmin Vadhu list online?",
                  answer: "To search Brahmin Vadhu list online you have to register free through MarathiVadhuVarSuchak.com matrimony."
                },
                {
                  question: "Which is the best Brahmin Vadhu Var Suchak Mandal Pune?",
                  answer: "MarathiVadhuVarSuchak.com Marathi matrimony is the best Brahmin Vadhu Var Suchak Mandal in Pune region."
                },
                {
                  question: "How to make Brahmin Vadhu Var Suchak cast wise search online?",
                  answer: "First, register free on MarathiVadhuVarSuchak.com Marathi matrimony to make Brahmin Vadhu Var caste wise search online."
                },
                {
                  question: "Which is the trusted Brahmin Vadhu Var Suchak Mandal Thane?",
                  answer: "MarathiVadhuVarSuchak.com Marathi matrimony is the most trusted Brahmin Vadhu Var Suchak Mandal in Thane region."
                },
                {
                  question: "How to do Brahmin Vadhu Var Suchak age wise search online?",
                  answer: "Register free on MarathiVadhuVarSuchak.com matrimony to make Brahmin Vadhu Var age wise search online."
                },
                {
                  question: "Which is the best Brahmin Vadhu Var Suchak Mandal Kolhapur?",
                  answer: "MarathiVadhuVarSuchak.com Marathi matrimony is the No.1 Brahmin Vadhu Var Suchak Mandal in Kolhapur region."
                },
                {
                  question: "Which is the trusted Brahmin Vadhu Var Suchak Mandal Aurangabad?",
                  answer: "MarathiVadhuVarSuchak.com matrimony is the No.1 Brahmin Vadhu Var Suchak Mandal in Aurangabad region."
                },
                {
                  question: "How to search Brahmin Vadhu Var Biodata online?",
                  answer: "Register free through MarathiVadhuVarSuchak.com matrimony to search Brahmin Vadhu Var Biodata online."
                },
                {
                  question: "Which is the best Brahmin Vadhu Var Suchak Mandal Nagpur?",
                  answer: "MarathiVadhuVarSuchak.com matrimony is the trusted No.1 Brahmin Vadhu Var Suchak Mandal in Nagpur region."
                },
                {
                  question: "Which is the best Brahmin Vadhu Var Suchak Kendra near me?",
                  answer: "Internet made it easy now, Brahmin Vadhu Var can register free online through MarathiVadhuVarSuchak.com matrimony site."
                },
                {
                  question: "How to do Brahmin Vadhu Var Suchak Kendra photos search online?",
                  answer: "Brahmin Vadhu Var has to register free on MarathiVadhuVarSuchak.com site to search profiles with photo."
                },
                {
                  question: "How to search Brahmin Vadhu Var Suchak Kendra phone number?",
                  answer: "Visit MarathiVadhuVarSuchak.com matrimony site and search support phone number in contact us section."
                },
                {
                  question: "Where I will get Brahmin Vadhu Var Suchak Kendra contact number?",
                  answer: "Visit MarathiVadhuVarSuchak.com matrimony site contact us section page for phone number."
                },
                {
                  question: "How to join Brahmin Vadhu Var WhatsApp group?",
                  answer: "MarathiVadhuVarSuchak.com matrimony does not have any WhatsApp group due to privacy policy."
                },
                {
                  question: "How to search Marathi Brahmin grooms photos online?",
                  answer: "To search Marathi Brahmin grooms photos online, brides need to register free on MarathiVadhuVarSuchak.com matrimony."
                },
                {
                  question: "How to search Marathi Brahmin grooms list online?",
                  answer: "To search Marathi Brahmin grooms list online, Brahmin brides have to register free through MarathiVadhuVarSuchak.com site."
                },
                {
                  question: "How to search Marathi Brahmin grooms for marriage?",
                  answer: "Register free through MarathiVadhuVarSuchak.com site to search Marathi Brahmin grooms for marriage."
                },
                {
                  question: "How to search best Marathi Brahmin grooms online?",
                  answer: "Register free on MarathiVadhuVarSuchak.com site to search best Marathi Brahmin grooms profiles online."
                },
                {
                  question: "How to search Marathi Brahmin grooms in USA?",
                  answer: "To search Marathi Brahmin grooms in USA, register free on MarathiVadhuVarSuchak.com Marathi matrimony site."
                },
                {
                  question: "How to search Marathi Brahmin grooms Canada?",
                  answer: "To search Marathi Brahmin grooms in Canada, register free through MarathiVadhuVarSuchak.com matrimony site."
                },
                {
                  question: "How to search Marathi Brahmin grooms UK?",
                  answer: "To search Marathi Brahmin grooms in United Kingdom, first register free through MarathiVadhuVarSuchak.com Marathi matrimony site."
                },
                {
                  question: "How to search the divorcee Marathi Brahmin groom online?",
                  answer: "To search the divorcee Marathi Brahmin groom online, Brahmin brides have to register on MarathiVadhuVarSuchak.com Marathi matrimony."
                }
              ].map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">
                      {faq.question}
                    </h3>
                    <svg
                      className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${
                        openFAQ === index ? 'rotate-180' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div
                    className={`px-6 transition-all duration-300 ease-in-out ${
                      openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
                    }`}
                  >
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Marathi Brahmin Matrimony for Marathi Brahmin Communities"
        items={communityServices}
      />

    </div>
  );
}
